import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Count from "../components/Count";
import { TitleText } from "../../../ui/Text";
import Header from "../components/Header";
import SearchInput from "../../../ui/SearchInput";
import Accordion from "../../../ui/Accordion";
import Modal from "../../../ui/Modal";
import { useParams, useLocation } from "react-router-dom";
import { GetHook, postEndpoint, putEndpoint } from "../../../api/api";
import { SCORECARD_URL, KPI_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { parseDropdown } from "../../../utils/parseDropdown";
import Axios from "../../../utils/axios";
import AddKpi from "./AddKpi";
import Comment from "../../../ui/Comment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

interface IProps {
  scorecard_id?: any;
  scorecard?: any;
}

const KPIsComponent = ({ scorecard_id, scorecard }: IProps) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [kpis, setKpis] = useState<any>([]);
  const [kpi, setKpi] = useState<any>([]);
  const [objective, setObjective] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [kpiId, setKpiId] = useState();
  const [editData, setEditData] = useState<any>([]);
  const [modalContent, setModalContent] = useState("kpi");
  const [filteredKpis, setFilteredKpis] = useState([]);

  const { id }: any = useParams();

  const { data, error, pending, reload } = GetHook(
    `${SCORECARD_URL}/${scorecard_id}/kpi/v1?objective_id=${
      objective && get(objective[0], "objective_id")
    }`
  );

  const location = useLocation();
  const isAddMode = !kpiId;

  const fetchObjective = () => {
    Axios.get(`${SCORECARD_URL}/${scorecard_id}/objective/v1`).then((res) => {
      const { returned_resultset } = get(res, "data");
      setObjective(
        returned_resultset.filter((objective) => objective.objective_id === id)
      );
    });
  };

  const fetchKpi = () => {
    Axios.get(
      `${KPI_URL}?objective_id=${
        objective && get(objective[0], "objective_id")
      }`
    ).then((res) => {
      const { returned_resultset } = get(res, "data");
      setKpi(returned_resultset);
    });
  };

  useEffect(() => {
    fetchObjective();
    setKpis(data);
    return () => {};
  }, [data, id]);

  useEffect(() => {
    if (isModalOpen) {
      fetchKpi();
    }
    return () => {};
  }, [isModalOpen]);

  const toggleModal = (content, kpi) => {
    setModalContent(content);
    setKpiId(kpi.id);
    setisModalOpen(true);
  };

  const setEdit = (kpi) => {
    setIsEdit(true);
    setKpiId(kpi.id);
    setEditData(kpi);
    setisModalOpen(true);
  };

  const closeModal = () => {
    setModalContent("kpi");
    setisModalOpen(false);
    setIsEdit(false);
    setKpiId(undefined);
    setEditData({});
    reload(get(location, "key"));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${SCORECARD_URL}/${scorecard_id}/kpi/${id}`)
            .then((res) => {
              setKpis(kpis.filter((kpi: any) => kpi.id != id));
              toast.success("KPI has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };
  const handleKpiSearch = (e) => {
    const filtered = kpis.filter((kpi) =>
      kpi.kpi_name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    if (e?.target.value) {
      setFilteredKpis(filtered);
    } else {
      setFilteredKpis([]);
    }
  };
  
  
  const kpisWeght  = kpis.map(function(i) {
    return i?.weight;
  });
  let Objsum = 0;
  
  for (let i = 0; i < kpisWeght?.length; i++) {
      Objsum += kpisWeght[i];
  }

  return (
    <KPIsContainer>
      <KPIsHeaderSection>
        <TitleText style={{ width: "80%" }}>
          {objective && objective[0]?.objective?.name}
        </TitleText>
        <DescriptionSection>
          {objective && get(objective[0], "notes")}
        </DescriptionSection>
        <TitleText style={{ width: "80%" }}>
        Total Kpis Weight = {Objsum}
        </TitleText>
      </KPIsHeaderSection>
      <Header
        title="KPIs"
        count={kpis && kpis.length}
        setisModalOpen={setisModalOpen}
      />
      {isModalOpen && (
        <Modal
          title={!isEdit ? "Add new KPI" : "Edit KPI"}
          closeModal={closeModal}
          noHeader={modalContent === "kpi" ? false : true}
          width={modalContent === "comment" ? "30em" : "40em"}
          noFooter
        >
          {modalContent === "kpi" ? (
            <AddKpi
              isAddMode={isAddMode}
              isEdit={isEdit}
              scorecard_id={scorecard_id}
              kpi={kpi}
              closeModal={closeModal}
              editData={editData}
            />
          ) : (
            <Comment
              closeModal={closeModal}
              url={`scorecardkpi/${kpiId}`}
              scorecard_id={scorecard_id}
            />
          )}
        </Modal>
      )}

      <SearchInput handleChange={handleKpiSearch} />
      <ListContainer>
        {(filteredKpis?.length ? filteredKpis : kpis).map((kpi) => (
          <Accordion
            kpi={kpi}
            key={kpi?.kpi_id}
            showEdit={setEdit}
            handleDelete={() => handleDelete(kpi?.kpi_id)}
            isActive={(get(scorecard, "[0]status") === "active" || get(scorecard, "[0]status") === "pending-approval") ? true : false}
            toggleComment={toggleModal}
            hasComments
          />
        ))}
      </ListContainer>
    </KPIsContainer>
  );
};

export default KPIsComponent;

const KPIsContainer = styled.div`
  display: grid;
  grid-template-rows: 18em 5em 4.25em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const KPIsHeaderSection = styled.div`
  display: grid;
  grid-template-rows: 3em 7em;
  padding: 1em;
  padding-top: 2.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const DescriptionSection = styled.div`
  font-size: 0.75em;
  font-weight: 500;
  font-style: regular;
  color: #cdd3de;
`;
